import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import type { FrontendPlugin } from '@backstage/frontend-plugin-api';
import { UserSettingsLandingPage } from '@internal/backstage-plugin-landing-pages';
import { RiSettings3Fill } from '@remixicon/react';

export const userSettingsPluginOverride: FrontendPlugin =
  userSettingsPlugin.withOverrides({
    extensions: [
      userSettingsPlugin.getExtension('page:user-settings').override({
        params: {
          icon: <RiSettings3Fill />,
        },
      }),
      userSettingsPlugin
        .getExtension('sub-page:user-settings/general')
        .override({
          params: {
            loader: async () => <UserSettingsLandingPage />,
          },
        }),
    ],
  });
